export const HOUSEHOLD_STATUS_LABELS = {
  // --- Data Collection phase ---
  created: "Created",
  active: "In progress",
  general_info_completed: "General Info Completed",
  household_setup_initiated: "Household Setup Initiated",
  shared_with_client: "With Client",
  shared_with_client_onboarding_done: "Client Onboarding Done",
  pending_advisor_review: "Back with Advisor",
  shared_with_client_for_final_review: "With Client for Final Review",
  advisor_final_review: "Advisor Final Review",
  data_collection_completed: "Data Collection Completed",

  // --- Repapering phase ---
  forms_generated: "Forms Generated",
  docusign_initiated: "Signature Execution · Envelope Created",
  docusign_completed: "Signature Execution · Envelope Complete",
  account_opened: "Account Opened",
  toa_completed: "TOA Completed",
  firm_paperwork_in_progress: "Firm Paperwork In Progress",
  nigo: "NIGO",
  under_dispute: "Query Raised",
  completed: "Household Completed",
  closed: "Closed",
  inactive: "Inactive",

  // --- Pseudo-statuses (computed server-side, used as filter values only) ---
  stale_household: "Critical Pending",
  hand_holding_required: "Hand-Holding Required",
  unread_comments: "Unread comments",
  has_comments: "Has comments",
};

export const HOUSEHOLD_SUB_STATUS_LABELS = {
  enriched: "Enriched",
  client_editing: "Client Editing",
  hand_holding_required: "Hand-Holding Required",
  docusign_envelope_created: "DocuSign Envelope Created",
  docusign_envelope_sent: "DocuSign Envelope Sent",
  docusign_envelope_complete: "DocuSign Envelope Complete",
  docusign_envelope_void: "DocuSign Envelope Voided",
  pending_for_execution: "Pending for Execution",
  nigo_account_level: "NIGO — Account Level",
  nigo_service_level: "NIGO — Service Level",
  nigo_transfer_level: "NIGO — Transfer Level",
};

/**
 * Legacy values that were removed from the backend enum. Kept ONLY so older
 * data or saved views referencing them render with a recognisable label
 * instead of a raw enum string. Do NOT include these in any "available
 * statuses" dropdown.
 */
export const LEGACY_REMOVED_STATUS_LABELS = {
  submitted_to_custodian: "Submitted to Custodian (legacy)",
  transfer_in_progress: "Transfer in Progress (legacy)",
  transfer_rejected: "Transfer Rejected (legacy)",
  partially_transferred: "Partially Transferred (legacy)",
};


export const STATUS_FILTER_OPTIONS = [
  "unread_comments",
  "has_comments",
  "active",
  "shared_with_client",
  "pending_advisor_review",
  "data_collection_completed",
  "forms_generated",
  "docusign_initiated",
  "docusign_completed",
  "account_opened",
  "toa_completed",
  "firm_paperwork_in_progress",
  "nigo",
  "under_dispute",
  "completed",
];

export const SUB_STATUS_FILTER_OPTIONS_BY_STATUS = {
  data_collection_completed: ["pending_for_execution"],
  nigo: ["nigo_account_level", "nigo_service_level", "nigo_transfer_level"],
};


export const labelForStatus = (s) =>
  HOUSEHOLD_STATUS_LABELS[s] ?? LEGACY_REMOVED_STATUS_LABELS[s] ?? s ?? "";

/** Resolve a sub-status enum value to a display label. */
export const labelForSubStatus = (s) =>
  HOUSEHOLD_SUB_STATUS_LABELS[s] ?? s ?? "";
